import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56dc8205"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-select" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("选择项目")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查询")

export function render(_ctx, _cache) {
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_project_type_select = _resolveComponent("project-type-select")
  const _component_a_form = _resolveComponent("a-form")
  const _component_table_wrapper = _resolveComponent("table-wrapper")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_input, {
        class: "s-input",
        disabled: _ctx.disabled,
        value: _ctx.valueName,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.valueName) = $event)),
        placeholder: "请输入项目名称",
        "allow-clear": "",
        maxlength: 100,
        onChange: _ctx.inputChange
      }, null, 8, ["disabled", "value", "onChange"]),
      _createVNode(_component_a_button, {
        type: "primary",
        class: "s-btn",
        onClick: _ctx.showModal
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = $event => ((_ctx.visible) = $event)),
      centered: true,
      keyboard: false,
      "mask-closable": false,
      title: "选择项目",
      width: "1100px",
      onCancel: _ctx.closeModal,
      onOk: _ctx.ok
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "项目名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.queryRef.projectName,
                  "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.queryRef.projectName) = $event)),
                  valueModifiers: { trim: true },
                  "allow-clear": "",
                  class: "w140",
                  placeholder: "请输入项目名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "项目类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_project_type_select, {
                  value: _ctx.queryRef.projectTypeId,
                  "onUpdate:value": _cache[2] || (_cache[2] = $event => ((_ctx.queryRef.projectTypeId) = $event)),
                  class: "w140",
                  placeholder: "请选择项目类型"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  onClick: _ctx.reset,
                  style: {"margin-left":"14px !important"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  loading: _ctx.loading,
                  type: "primary",
                  onClick: _ctx.search
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_table_wrapper, {
          dataSource: _ctx.dataSource,
          onOnTableChange: _ctx.onTableChange,
          onOnRadioChange: _ctx.onRadioChange,
          pagination: _ctx.pagination,
          loading: _ctx.loading,
          columns: _ctx.columns,
          showRadiobox: true,
          radioConfig: {checkRowKey:_ctx.selectedKeys?.id}
        }, null, 8, ["dataSource", "onOnTableChange", "onOnRadioChange", "pagination", "loading", "columns", "radioConfig"])
      ]),
      _: 1
    }, 8, ["visible", "onCancel", "onOk"])
  ]))
}